// assets/upside-pdp.js
// Simon 2026-10-02: product page layout "everything that decides the purchase is above the fold".
//   1. Flavour tiles: every product of the same brand + type + size (assets/upside-siblings.json,
//      built daily by card_facts.mjs). Each flavour stays its own product (reviews, SEO, SKUs);
//      a tile links to it on the same format.
//   2. Format cards: the Size buttons show price, price per 100 ml and "Best value".
//   3. Accordions: Description (3 lines + Read more), Ingredients & Nutrition, Shipping & Returns.
//      Content is moved, not removed: still in the page for Google.
//   4. Ask Alix under the photo (desktop), with suggested questions.
// Simon 2026-10-03 (later): mix / variety packs always last in the flavour row; tile labels never break inside
//   a word (a long word shrinks the font of its tile instead); a new product not in stock yet shows "Coming soon"
//   (red) instead of "Out of stock"; any sold-out product gets "Join the waitlist" in place of the disabled
//   Add to Cart (the theme's Klaviyo back-in-stock trigger, moved up and relabelled, see waitlist()).
(function () {
  'use strict';
  if (window.__UD_PDP__) return;
  window.__UD_PDP__ = true;

  var me = document.currentScript;
  var SIB_URL = me && me.getAttribute('data-siblings');
  var FACTS_URL = me && me.getAttribute('data-facts');
  var FBT_URL = me && me.getAttribute('data-lists');
  var FEAT = ((me && me.getAttribute('data-features')) || 'def,flav,fmt,acc,alix,mob,wl').split(','); // Simon 2026-10-03: + def (most sold format preselected)
  function on(f) { return FEAT.indexOf(f) > -1; }
  var FR = (document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var m = location.pathname.match(/\/products\/([^\/?#]+)/);
  if (!m) return;
  var PAGE_HANDLE = decodeURIComponent(m[1]);

  var T = FR ? {
    flavour: 'Saveur', desc: 'Description', details: 'Détails du produit', ingr: 'Ingrédients et valeurs nutritives', ship: 'Livraison et retours',
    more: 'Lire la suite', less: 'Réduire', add: 'Ajouter au panier', best: 'Meilleur prix', out: 'Épuisé', soon: 'Bientôt disponible', wl: 'Rejoindre la liste d\u2019attente', ask: 'Demandez à Alix', other: 'Autre question',
    shipText: '<p><b>Québec et Ontario :</b> livraison gratuite dès 75 $ (sinon 9,99 $), 1 à 3 jours ouvrables.<br><b>Ouest (AB, BC, MB, SK) :</b> livraison gratuite dès 125 $ (sinon 19,99 $), 3 à 7 jours ouvrables.<br><b>Atlantique (NB, NS, PE, NL) :</b> livraison gratuite dès 150 $ (sinon 19,99 $), 3 à 7 jours ouvrables.<br>Commandes préparées en 1 jour ouvrable.</p><p><b>Retours :</b> toutes les ventes sont finales. Comme il s’agit de produits alimentaires, nous n’acceptons ni retours ni échanges. Produit reçu endommagé? Écrivez à <a href="mailto:info@upsidedrinks.ca">info@upsidedrinks.ca</a> avec une photo et nous trouverons une solution.</p><p><a href="' + ROOT + 'pages/shipping-policy">Politique de livraison complète</a></p>',
    qs: ['Combien de sucre contient-il?', 'Quel goût a-t-il?', 'Est-il sans gluten?', 'Quelle saveur est la plus populaire?']
  } : {
    flavour: 'Flavour', desc: 'Description', details: 'Product details', ingr: 'Ingredients & Nutrition', ship: 'Shipping & Returns',
    more: 'Read more', less: 'Read less', add: 'Add to cart', best: 'Best value', out: 'Out of stock', soon: 'Coming soon', wl: 'Join the waitlist', ask: 'Ask Alix', other: 'Ask something else',
    shipText: '<p><b>Ontario &amp; Québec:</b> free shipping on $75+ (otherwise $9.99), 1 to 3 business days.<br><b>West (AB, BC, MB, SK):</b> free shipping on $125+ (otherwise $19.99), 3 to 7 business days.<br><b>Atlantic (NB, NS, PE, NL):</b> free shipping on $150+ (otherwise $19.99), 3 to 7 business days.<br>Orders are prepared within 1 business day.</p><p><b>Returns:</b> all sales are final. Because these are food products, we can’t accept returns or exchanges. Item arrived damaged? Email <a href="mailto:info@upsidedrinks.ca">info@upsidedrinks.ca</a> with a photo and we’ll make it right.</p><p><a href="' + ROOT + 'pages/shipping-policy">Full shipping policy</a></p>',
    qs: ['How much sugar is in it?', 'What does it taste like?', 'Is it gluten-free?', 'Which flavour is the most popular?']
  };

  function getJSON(u) { return fetch(u, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw r.status; return r.json(); }); }
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function img(src, w) { if (!src) return ''; if (src.indexOf('//') === 0) src = 'https:' + src; return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function packCount(t) { t = String(t || '').toLowerCase(); if (/^1\s*(can|canette|bottle|bouteille)\b/.test(t)) return 1; var n = t.match(/^(\d+)/); return n ? +n[1] : 1; }
  // Simon 2026-10-03: flavour label = the title without the brand and without any separator, so a line can
  // never start with "-" ("Leitz Eins-Zwei Zero - Riesling - Mousseux Blanc" gives "Riesling Mousseux Blanc").
  // Splits on a spaced hyphen, en/em dash, middle dot or bar; "Eins-Zwei" (no spaces) stays whole.
  function shortName(title) {
    var parts = String(title || '').split(/\s+[-–—·|]+\s+/).map(function (x) { return x.trim(); }).filter(Boolean);
    if (parts.length > 1) parts = parts.slice(1);
    return parts.join(' ').replace(/^[\s\-–—·|]+|[\s\-–—·|]+$/g, '');
  }
  // Simon 2026-10-03: "new" = tagged new / _label_new / _label_coming soon, or created in the last 60 days.
  // A new product that is not available reads "Coming soon" instead of "Out of stock".
  function isNew(p) {
    var tg = ((p && p.tags) || []).map(function (t) { return String(t).toLowerCase().trim(); });
    if (tg.indexOf('new') > -1 || tg.indexOf('_label_new') > -1 || tg.indexOf('_label_coming soon') > -1) return true;
    var c = Date.parse((p && p.created_at) || '');
    return !!c && Date.now() - c < 60 * 864e5;
  }
  // mix / variety packs go last in the flavour row
  var MIX = /variety|mix\s*pack|mixte|sampler|assortiment|vari[eé]t[eé]|sixer|discovery|bundle/i;
  // a word too long for its tile: shrink that tile's font instead of breaking the word
  function fitTiles(root) {
    if (!root) return;
    root.querySelectorAll('.ud-flav__t span, .ud-flav__t em').forEach(function (sp) {
      sp.style.fontSize = '';
      var fs = parseFloat(getComputedStyle(sp).fontSize) || 10, n = 0;
      while (sp.scrollWidth > sp.clientWidth + 0.5 && fs > 7 && n++ < 12) { fs -= 0.5; sp.style.fontSize = fs + 'px'; }
    });
  }
  function region() { var v = ''; try { v = localStorage.getItem('ecomific_region') || ''; } catch (e) {} return v; }

  var css = [
    // flavour tiles
    '.ud-flav{margin:4px 0 14px}',
    '.ud-flav__lbl,.ud-fmt__lbl{font-size:15px;font-weight:700;margin:0 0 8px}',
    '.ud-flav__lbl span{font-weight:500}',
    '.ud-flav__grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(72px,1fr));gap:6px}',
    '.ud-flav__t{display:block;border:1px solid #e1e4ea;border-radius:8px;padding:5px 3px 6px;text-align:center;font-size:10.5px;line-height:1.2;color:inherit;text-decoration:none;background:#fff;position:relative}',
    '.ud-flav__t img{width:100%;height:56px;object-fit:contain;display:block;margin-bottom:4px}',
    '.ud-flav__t:hover{border-color:#37446E}',
    '.ud-flav__t.is-on{border:2px solid #37446E;box-shadow:0 0 0 2px #e8ebf3}',
    '.ud-flav__t.is-off{opacity:.45}',
    '.ud-flav__t em{display:block;font:9px Arial,sans-serif;color:#6b7280;font-style:normal;margin-top:2px;overflow-wrap:normal;word-break:normal;hyphens:none}',
    // Simon 2026-10-03: new product not in stock yet = "Coming soon" in red, tile only lightly faded (still a link to its page)
    '.ud-flav__t.is-soon{border-style:dashed;border-color:#e3b5af}',
    '.ud-flav__t.is-soon img{opacity:.7}',
    '.ud-flav__t.is-soon span{opacity:.8}',
    '.ud-flav__t.is-soon em{color:#c0392b;font-weight:700}',
    '.ud-flav__t.is-soon.is-on{border-style:solid;border-color:#37446E}',
    // Simon 2026-10-02: tile labels centered with inner padding, never touching the border (selected or not), long names wrap on 2 lines
    '.ud-flav__t{box-sizing:border-box;min-width:0;padding:5px 7px 7px}',
    '.ud-flav__t.is-on{padding:4px 6px 6px}',
    '.ud-flav__t span{display:block;font-size:10px;line-height:1.25;letter-spacing:0;overflow-wrap:normal;word-break:normal;hyphens:none;text-wrap:balance}',
    // Simon 2026-10-03: at most 3 lines on desktop, 2 on phones (ellipsis), never cut inside a word
    '.ud-flav__t span{display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:3;overflow:hidden;hyphens:none;word-break:normal}',
    // format cards (theme Size buttons)
    '[id$="__main"] .ud-fmt .variant-input-wrap{display:flex!important;flex-wrap:wrap;gap:8px;overflow:visible!important;padding-top:13px!important;margin-top:-4px}',
    '[id$="__main"] .ud-fmt,[id$="__main"] .ud-fmt .variant-wrapper,[id$="__main"] .ud-fmt fieldset,[id$="__main"] .ud-fmt .variant-input{overflow:visible!important}',
    '[id$="__main"] .ud-fmt{margin-bottom:0!important;padding-bottom:18px!important}',
    '[id$="__main"] .ud-fmt .variant-input-wrap{align-items:stretch}',
    '[id$="__main"] .ud-fmt .variant-input{display:flex!important;align-self:stretch}',
    '[id$="__main"] .ud-fmt .variant-input label.variant__button-label{height:100%;justify-content:flex-start!important}',
    '[id$="__main"] .ud-fmt .variant__button-label{display:flex!important;flex-direction:column;align-items:flex-start;justify-content:center;text-align:left;min-width:118px;padding:8px 12px!important;line-height:1.25;border-radius:8px!important;position:relative;margin:0!important}',
    '[id$="__main"] .ud-fmt .ud-fmt__p{font-size:15px;font-weight:700;margin-top:2px}',
    '[id$="__main"] .ud-fmt .ud-fmt__u{font:11px Arial,sans-serif;opacity:.75}',
    '[id$="__main"] .ud-fmt .ud-fmt__b{font:700 10.5px Arial,sans-serif;color:#1c7c3c;margin-top:2px}',
    '[id$="__main"] .ud-fmt input:checked + label .ud-fmt__b{color:#7ee2a0}',
    // accordions
    '.ud-acc{border-top:1px solid #e5e7ee;margin:6px 0 14px}',
    '.ud-acc details{border-bottom:1px solid #e5e7ee}',
    '.ud-acc summary{list-style:none;cursor:pointer;padding:13px 2px;font-weight:700;font-size:15px;display:flex;justify-content:space-between;align-items:center}',
    '.ud-acc summary::-webkit-details-marker{display:none}',
    '.ud-acc summary:after{content:"";width:9px;height:9px;border-right:2px solid #37446E;border-bottom:2px solid #37446E;transform:rotate(45deg);margin:-4px 6px 0 0;transition:transform .2s}',
    '.ud-acc details[open] summary:after{transform:rotate(-135deg);margin-top:4px}',
    '.ud-acc__body{padding:0 2px 14px;font-size:14px}',
    '.ud-acc__body p{margin:0 0 8px}',
    '.ud-clamp{max-height:4.6em;overflow:hidden;position:relative}',
    '.ud-clamp.is-open{max-height:none}',
    '.ud-clamp:not(.is-open):after{content:"";position:absolute;left:0;right:0;bottom:0;height:1.6em;background:linear-gradient(rgba(255,255,255,0),#fff)}',
    '.ud-more{background:none;border:0;padding:0;margin-top:4px;color:#37446E;text-decoration:underline;cursor:pointer;font-size:13px}',
    // Ask Alix under the photo
    '.ud-alix{margin:18px 0 0}',
    '.ud-alix__h{font-size:14px;font-weight:700;display:flex;align-items:center;gap:6px;margin:0}',
    '.ud-alix__h i{width:18px;height:18px;border-radius:50%;background:linear-gradient(135deg,#37446E,#6b7fd7);display:inline-block}',
    '.ud-alix__q{display:flex;flex-wrap:wrap;gap:8px;margin:10px 0}',
    '.ud-alix__q button{background:#e8eefb;color:#1f3b73;border:0;border-radius:16px;padding:8px 12px;font-size:12.5px;cursor:pointer;font-family:inherit}',
    '.ud-alix__q button.k{background:#37446E;color:#fff}',
    // ---- phones (Simon 2026-10-02: optimize mobile) ----
    '@media (max-width:768px){' +
      // flavours: one row that scrolls sideways instead of 3 rows of tiles
      '.ud-flav__grid{display:flex!important;overflow-x:auto;gap:6px;scroll-snap-type:x mandatory;padding-bottom:4px;scrollbar-width:none}' +
      '.ud-flav__grid::-webkit-scrollbar{display:none}' +
      '.ud-flav__t{flex:0 0 76px;scroll-snap-align:start}' +
      '.ud-flav__t{padding:5px 5px 7px}.ud-flav__t.is-on{padding:4px 4px 6px}.ud-flav__t span{font-size:9.5px;-webkit-line-clamp:2}' + // Simon 2026-10-02: narrower tile, so "Chardonnay" stays whole inside the padding
      // format cards: always on one line, equal width
      '[id$="__main"] .ud-fmt .variant-input-wrap{flex-wrap:nowrap!important;gap:6px!important}' +
      '[id$="__main"] .ud-fmt .variant-input{flex:1 1 0!important;min-width:0}' +
      '[id$="__main"] .ud-fmt .variant__button-label{min-width:0!important;width:100%;padding:7px 8px!important}' +
      '[id$="__main"] .ud-fmt .variant__button-label > span:first-child{font-size:14px;white-space:nowrap}' +
      '[id$="__main"] .ud-fmt .ud-fmt__p{font-size:14px}' +
      '[id$="__main"] .ud-fmt .ud-fmt__u{font-size:10px}' +
      // quantity and Add to Cart side by side
      '[id$="__main"] .ecomific-pdp-controls-row{display:flex!important;flex-direction:row!important;flex-wrap:nowrap!important;gap:8px!important;align-items:flex-start!important}' +
      '[id$="__main"] .ecomific-pdp-controls-row > .product-block--quantity{flex:0 0 112px!important;width:112px!important;max-width:112px!important}' +
      '[id$="__main"] .ecomific-pdp-controls-row > .product-block--quantity .js-qty__wrapper{width:100%!important;min-height:54px}' +
      '[id$="__main"] .ecomific-pdp-controls-row > .product-block--buy-buttons{flex:1 1 auto!important;min-width:0}' +
      // sticky Add to cart bar (Simon 2026-10-03: title + format + price, hides at the footer, lifts the floating widgets)
      '.ud-sticky{position:fixed;left:0;right:0;bottom:0;z-index:2147482500;background:#fff;border-top:1px solid #e5e7ee;box-shadow:0 -4px 16px rgba(0,0,0,.08);display:flex;align-items:center;gap:10px;padding:9px 12px calc(9px + env(safe-area-inset-bottom));transform:translateY(110%);visibility:hidden;transition:transform .25s,visibility 0s .25s}' +
      'html.ud-sticky-on .ud-sticky{transform:none;visibility:visible;transition:transform .25s}' +
      'body.rebuy-cart-visible .ud-sticky,html.ud-cart-open .ud-sticky{transform:translateY(110%)!important}' +
      '.ud-sticky img{width:42px;height:42px;object-fit:contain;flex:0 0 42px}' +
      '.ud-sticky__txt{flex:1 1 auto;min-width:0;line-height:1.25}' +
      '.ud-sticky__t{display:block;font-size:13.5px;font-weight:700;color:#202A36;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
      '.ud-sticky__s{display:block;font:12px Arial,Helvetica,sans-serif;color:#4b5563;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:2px}' +
      '.ud-sticky__s b{color:#202A36;font-weight:700}' +
      '.ud-sticky__btn{flex:0 0 auto;height:46px;padding:0 16px;border:0;border-radius:3px;background:#37446E;color:#fff;font-weight:700;font-size:15px;letter-spacing:.02em;font-family:inherit;cursor:pointer;max-width:48%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
      '.ud-sticky__btn[disabled]{opacity:.5;cursor:default}' +
      // lift the Sober October rail and the chat bubble above the bar while it shows (--ud-sticky-h = measured bar height)
      'html.ud-sticky-on .upside-so-rail{bottom:calc(var(--ud-sticky-h,70px) + 10px)!important;transition:bottom .25s}' +
      'html.ud-sticky-on iframe#chat-button,html.ud-sticky-on iframe#chat-campaigns,html.ud-sticky-on iframe#mount-floating-engagement-widget,html.ud-sticky-on [class*="bpFab"]{transform:translateY(calc(-1 * var(--ud-sticky-h,70px)))!important;transition:transform .25s}' +
    '}',
    '@media (min-width:769px){.ud-sticky{display:none!important}}',
    // waitlist (sold out): status line + "Join the waitlist" right under the formats, Add to Cart row hidden
    '[id$="__main"].ud-oos .ecomific-pdp-controls-row{display:none!important}',
    '.ud-wl__st{display:none;margin:2px 0 0;font-size:15px;font-weight:700;color:#4b5563}',
    '.ud-wl__st.is-soon{color:#c0392b}',
    '[id$="__main"].ud-oos .ud-wl__st{display:block}',
    '[id$="__main"] .ud-wl .klaviyo-bis-trigger{margin:8px 0 4px!important}',
    // remove the old labels/spacing that the new blocks replace
    '[id$="__main"] .ud-hide{display:none!important}'
  ].join('');

  Promise.all([
    SIB_URL ? getJSON(SIB_URL).catch(function () { return {}; }) : {},
    FACTS_URL ? getJSON(FACTS_URL).catch(function () { return {}; }) : {},
    FBT_URL ? getJSON(FBT_URL).catch(function () { return {}; }) : {},
    getJSON(ROOT + 'products/' + PAGE_HANDLE + '.js').catch(function () { return null; })
  ]).then(function (r) {
    var sib = r[0] || {}, facts = r[1] || {}, fr = (r[2] && r[2]._fr) || {}, prod = r[3];
    if (!prod) return;
    var back = {}; for (var en in fr) back[fr[en]] = en;
    var EN = back[PAGE_HANDLE] || PAGE_HANDLE;
    var loc = function (h) { return (FR && fr[h]) || h; };
    var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);
    var go = function () {
      if (on('def')) try { defaultFormat(prod, facts[EN]); } catch (e) {}
      if (on('fmt')) try { formats(prod, facts[EN]); } catch (e) {}
      if (on('flav')) try { flavours(prod, EN, sib[EN] || [], loc); } catch (e) {}
      if (on('acc')) try { accordions(); } catch (e) {}
      if (on('alix')) try { alix(); } catch (e) {}
      if (on('mob')) try { sticky(prod); } catch (e) {}
      if (on('wl')) try { waitlist(prod); } catch (e) {}
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
  }).catch(function () {});

  function main() { return document.querySelector('[id^="shopify-section-template"][id$="__main"]'); }
  function sizeBlock() {
    var w = main() && main().querySelector('.variant-wrapper[data-type="button"]');
    return w ? (w.closest('.product-block') || w.parentNode) : null;
  }

  // ---------- 2. format cards ----------
  function formats(prod, f) {
    if (!prod.options || prod.options.length !== 1) return;
    var blk = sizeBlock(); if (!blk) return;
    blk.classList.add('ud-fmt');
    var ml = f && f[0];
    var units = {};
    prod.variants.forEach(function (v) { if (ml) units[v.id] = v.price / 100 / (packCount(v.title) * ml) * 100; });
    var avail = prod.variants.filter(function (v) { return v.available && units[v.id]; });
    var best = null;
    if (avail.length > 1) { best = avail.reduce(function (a, b) { return units[b.id] < units[a.id] ? b : a; }); }
    blk.querySelectorAll('.variant-input').forEach(function (inp) {
      var val = inp.getAttribute('data-value');
      var v = prod.variants.filter(function (x) { return x.option1 === val; })[0];
      var lab = inp.querySelector('label');
      if (!v || !lab || lab.querySelector('.ud-fmt__p')) return;
      lab.innerHTML = '<span>' + esc(val.replace(/\s*\(.*?\)\s*/g, ' ').trim()) + '</span><span class="ud-fmt__p">' + money(v.price) + '</span>' +
        (units[v.id] ? '<span class="ud-fmt__u">$' + units[v.id].toFixed(2) + ' / 100 ml</span>' : '') +
        (best && best.id === v.id && units[v.id] < Math.max.apply(null, avail.map(function (a) { return units[a.id]; })) - 0.005 ? '<span class="ud-fmt__b">' + T.best + '</span>' : '');
    });
  }

  // ---------- 1. flavour tiles ----------
  function flavours(prod, EN, list, loc) {
    if (!list.length) return;
    var blk = sizeBlock() || (main() && main().querySelector('.product-block--price'));
    if (!blk) return;
    var reg = region();
    var hs = list.map(function (x) { var a = x.split('|'); return { h: a[0], r: a[1] || '' }; })
      .filter(function (x) { return !x.r || !reg || (x.r === 'e' ? reg === 'east' : reg === 'west'); })
      .map(function (x) { return x.h; }).slice(0, 23);
    Promise.all(hs.map(function (h) { return getJSON(ROOT + 'products/' + loc(h) + '.js').then(function (p) { return { h: h, p: p }; }, function () { return null; }); }))
      .then(function (rs) {
        var cur = { h: EN, p: prod };
        var all = rs.filter(Boolean).concat([cur]).sort(function (a, b) { return (MIX.test(a.p.title) - MIX.test(b.p.title)) || shortName(a.p.title).localeCompare(shortName(b.p.title)); });
        if (all.length < 2) return;
        var form = main().querySelector('form[action*="/cart/add"] [name="id"]');
        var curVar = form && prod.variants.filter(function (v) { return String(v.id) === String(form.value); })[0];
        var tiles = all.map(function (x) {
          var p = x.p, on = x === cur;
          var same = curVar && p.variants.filter(function (v) { return v.option1 === curVar.option1 && v.available; })[0];
          var href = ROOT + 'products/' + p.handle + (same ? '?variant=' + same.id : '');
          var soon = !p.available && isNew(p);
          return '<a class="ud-flav__t' + (on ? ' is-on' : '') + (p.available ? '' : (soon ? ' is-soon' : ' is-off')) + '" href="' + href + '"' + (on ? ' aria-current="true"' : '') + '>' +
            '<img src="' + img(p.featured_image, 140) + '" alt="" loading="lazy"><span>' + esc(shortName(p.title)) + '</span>' + (p.available ? '' : '<em>' + (soon ? T.soon : T.out) + '</em>') + '</a>';
        });
        var el = document.createElement('div');
        el.className = 'ud-flav';
        el.innerHTML = '<p class="ud-flav__lbl">' + T.flavour + ': <span>' + esc(shortName(prod.title)) + '</span></p><div class="ud-flav__grid">' + tiles.join('') + '</div>';
        blk.parentNode.insertBefore(el, blk);
        fitTiles(el);
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { fitTiles(el); });
        var rt = 0;
        window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { fitTiles(el); }, 150); });
      });
  }

  // ---------- 7. waitlist on a sold-out product ----------
  // Simon 2026-10-03: the theme already renders the Klaviyo back-in-stock trigger (.klaviyo-bis-trigger in
  // .ecomific-pdp-feedback-block, shown by ecomific-availability-controller.js when the variant is sold out or
  // coming soon in the customer's region) and snippets/ud-pdp-bis-bridge.liquid turns a click on it into an inline
  // email form that subscribes the SELECTED VARIANT (Klaviyo "Subscribed to Back in Stock", flow UPpNWv).
  // Here we only move it right under the formats, relabel it "Join the waitlist", add a status line
  // ("Coming soon" in red for a new product, else "Out of stock") and hide the disabled Add to Cart row while it shows.
  function waitlist(prod) {
    var mn = main(); if (!mn) return;
    var fb = mn.querySelector('.ecomific-pdp-feedback-block');
    var trig = fb && fb.querySelector('.klaviyo-bis-trigger');
    var row = mn.querySelector('.ecomific-pdp-controls-row');
    if (!fb || !trig || !row) return;
    fb.classList.add('ud-wl');
    var soon = isNew(prod);
    var st = document.createElement('p');
    st.className = 'ud-wl__st' + (soon ? ' is-soon' : '');
    st.textContent = soon ? T.soon : T.out;
    fb.insertBefore(st, trig);
    var moves = 0, fixes = 0;
    function placeFb() { if (row.isConnected && row.parentNode && row.nextElementSibling !== fb && moves < 30) { moves++; row.parentNode.insertBefore(fb, row.nextSibling); } }
    var FRMSG = {
      "You're in! We'll let you know when it's back.": 'C\u2019est not\u00e9! Nous vous \u00e9crirons d\u00e8s son retour.',
      'Please enter a valid email.': 'Veuillez entrer un courriel valide.',
      'Something went wrong. Please try again.': 'Une erreur est survenue. Veuillez r\u00e9essayer.'
    };
    function sync() {
      if (trig.textContent.trim() !== T.wl && fixes < 50) { fixes++; trig.textContent = T.wl; }
      var btn = mn.querySelector('form[action*="/cart/add"] [type="submit"]');
      var shown = getComputedStyle(trig).display !== 'none';
      var off = !btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true';
      mn.classList.toggle('ud-oos', !!(shown && off));
      if (FR) {
        var inp = fb.querySelector('.ud-bis-inline input[type="email"]');
        if (inp && inp.placeholder !== 'vous@courriel.com') { inp.placeholder = 'vous@courriel.com'; inp.setAttribute('aria-label', 'Adresse courriel'); }
        var msg = fb.querySelector('.ud-bis-msg');
        if (msg && FRMSG[msg.textContent]) msg.textContent = FRMSG[msg.textContent];
      }
    }
    placeFb();
    sync();
    new MutationObserver(placeFb).observe(row.parentNode, { childList: true });
    new MutationObserver(sync).observe(fb, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['style', 'class'] });
    new MutationObserver(sync).observe(row, { subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
    document.addEventListener('change', function () { setTimeout(sync, 120); setTimeout(sync, 900); }, true);
  }

  // ---------- 3. accordions ----------
  function accordions() {
    var mn = main(); if (!mn) return;
    var rte = null;
    mn.querySelectorAll('[data-product-blocks] > .product-block .rte').forEach(function (r) { if (!rte && r.textContent.trim().length > 40) rte = r; });
    if (!rte) return;
    var descBlock = rte.closest('.product-block');
    // the fact lines can sit anywhere in the description block ("Ingredients: ...", "Size: 750mL")
    var INGR = /^(ingredients?|ingr\u00e9dients?|allergens?|allerg\u00e8nes?|contains|contient)\s*:/;
    var DETAIL = /^(origin|origine|country|pays|alcohol|alcool|abv|size|format|volume|brand|marque|grape|c\u00e9page|style)\s*:/;
    var ingrNodes = [], detailNodes = [];
    descBlock.querySelectorAll('p, li').forEach(function (n) {
      if (n.closest('.ud-nutri')) return;
      var t = (n.textContent || '').trim().toLowerCase();
      if (INGR.test(t)) ingrNodes.push(n); else if (DETAIL.test(t)) detailNodes.push(n);
    });
    // nutrition table and dietary tags: anywhere in the product section
    mn.querySelectorAll('.ud-nutri').forEach(function (n) { ingrNodes.push(n); });
    var diet = mn.querySelector('.dietary_metafields');
    if (diet && diet.textContent.trim()) ingrNodes.push(diet);
    var acc = document.createElement('div');
    acc.className = 'ud-acc';
    acc.innerHTML =
      // Description open on desktop (3 lines + Read more), closed on phones to keep the buy column short
      '<details' + (window.innerWidth > 768 ? ' open' : '') + '><summary>' + T.desc + '</summary><div class="ud-acc__body"><div class="ud-clamp rte"></div><button type="button" class="ud-more">' + T.more + '</button></div></details>' +
      (ingrNodes.length ? '<details><summary>' + T.ingr + '</summary><div class="ud-acc__body rte ud-ingr"></div></details>' : '') +
      (detailNodes.length ? '<details><summary>' + T.details + '</summary><div class="ud-acc__body rte ud-det"></div></details>' : '') +
      '<details><summary>' + T.ship + '</summary><div class="ud-acc__body">' + T.shipText + '</div></details>';
    var ingr = acc.querySelector('.ud-ingr'), det = acc.querySelector('.ud-det'), clamp = acc.querySelector('.ud-clamp');
    ingrNodes.forEach(function (n) { ingr.appendChild(n); });
    detailNodes.forEach(function (n) { det.appendChild(n); });
    // what is left of the description text
    [].slice.call(rte.childNodes).forEach(function (n) { if (n.nodeType === 1 && !n.textContent.trim() && !n.querySelector('img,iframe,video')) return; clamp.appendChild(n); });
    acc.querySelector('.ud-more').addEventListener('click', function () {
      var open = clamp.classList.toggle('is-open');
      this.textContent = open ? T.less : T.more;
    });
    // order in the buy column: Add to Cart > subscription choice > bundle > these bars.
    // The subscription app and the bundle render late, so keep re-placing the bars after them.
    function place() {
      var box = acc.parentNode || (mn.querySelector('[data-product-blocks]'));
      var last = mn.querySelector('.ecomific-pdp-controls-row');
      mn.querySelectorAll('[data-product-blocks] > *').forEach(function (n) {
        if (n === acc || !n.offsetHeight) return;
        if (n.matches('.ud-fbt') || n.querySelector('input[name="selling_plan"], input[name*="purchase"], [class*="selling-plan"], [class*="selling_plan"], [class*="subscription"]')) last = n;
      });
      if (!last) { if (!acc.parentNode) descBlock.parentNode.insertBefore(acc, descBlock); return; }
      // the waitlist block (waitlist()) stays glued under the Add to Cart row
      while (last.nextElementSibling && last.nextElementSibling !== acc && last.nextElementSibling.classList.contains('ud-wl')) last = last.nextElementSibling;
      if (last.nextSibling !== acc) last.parentNode.insertBefore(acc, last.nextSibling);
    }
    place();
    var mo = new MutationObserver(function () { place(); });
    mo.observe(mn.querySelector('[data-product-blocks]') || mn, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 15000);
    descBlock.classList.add('ud-hide');
    if (diet) { var db = diet.closest('[data-product-blocks] > *'); if (db && db !== descBlock && !db.contains(acc)) db.classList.add('ud-hide'); }
    setTimeout(function () { if (clamp.scrollHeight <= clamp.clientHeight + 4) { clamp.classList.add('is-open'); acc.querySelector('.ud-more').style.display = 'none'; } }, 300);
  }

  // ---------- 5. sticky Add to cart bar on phones ----------
  // Simon 2026-10-03: rebuilt. Phones only (<= 768px). Shows once the real Add to Cart button has scrolled
  // above the screen, hides when it is back in view, when the footer shows, or when the Rebuy cart is open.
  // Shows the product name (1 line), the selected format and its price; the button presses the REAL
  // Add to Cart, so the selected variant, quantity, subscription choice and the Rebuy Smart Cart behave the same.
  // Visibility is checked by IntersectionObserver (button + footer) and again on scroll, because a jump
  // (anchor link to the reviews) skips the observer, and the theme can re-render the button.
  function sticky(prod) {
    var mn = main(); if (!mn) return;
    var SEL = 'form[action*="/cart/add"] .add-to-cart, form[action*="/cart/add"] [type="submit"]';
    var btn = mn.querySelector(SEL);
    if (!btn || !('IntersectionObserver' in window)) return;
    var html = document.documentElement;
    var name = (prod && prod.title) || ((mn.querySelector('.product-single__title') || {}).textContent || document.title).trim();
    var bar = document.createElement('div');
    bar.className = 'ud-sticky';
    bar.setAttribute('aria-hidden', 'true');
    var im = mn.querySelector('.product__main-photos img');
    var src = (prod && prod.featured_image) ? img(prod.featured_image, 120) : (im ? (im.currentSrc || im.src) : '');
    bar.innerHTML = (src ? '<img src="' + esc(src) + '" alt="">' : '') +
      '<div class="ud-sticky__txt"><span class="ud-sticky__t"></span><span class="ud-sticky__s"></span></div>' +
      '<button type="button" class="ud-sticky__btn" tabindex="-1"></button>';
    document.body.appendChild(bar);
    var tEl = bar.querySelector('.ud-sticky__t'), sEl = bar.querySelector('.ud-sticky__s'), bEl = bar.querySelector('.ud-sticky__btn');
    tEl.textContent = name;
    tEl.title = name;
    function fill() {
      var fmt = mn.querySelector('.variant-input-wrap input:checked');
      var f = fmt && fmt.value ? fmt.value.replace(/\s*\(.*?\)\s*/g, ' ').trim() : '';
      // the price shown on the page ("$22<sup>49</sup>" after a format change), else the variant price
      var pe = mn.querySelector('[data-product-price]'), pr = '';
      if (pe) {
        var vh = pe.querySelector('.visually-hidden');
        if (vh && vh.textContent.trim()) pr = vh.textContent.trim();
        else { var c = pe.cloneNode(true); c.querySelectorAll('sup').forEach(function (x) { x.textContent = '.' + x.textContent; }); pr = c.textContent.replace(/\s+/g, ' ').trim(); }
      }
      if (!/\d/.test(pr) && prod) {
        var idEl = mn.querySelector('form[action*="/cart/add"] [name="id"]');
        var cv = idEl && prod.variants.filter(function (v) { return String(v.id) === String(idEl.value); })[0];
        pr = cv ? money(cv.price) : '';
      }
      sEl.innerHTML = esc(f) + (f && pr ? ' &middot; ' : '') + (pr ? '<b>' + esc(pr) + '</b>' : '');
      var off = btn.disabled || btn.getAttribute('aria-disabled') === 'true';
      bEl.disabled = off;
      bEl.textContent = (btn.textContent || '').replace(/\s+/g, ' ').trim() || T.add;
    }
    var footer = document.querySelector('footer.site-footer, .site-footer, footer');
    var raf = 0, io;
    function check() {
      raf = 0;
      if (!btn.isConnected) { var nb = mn.querySelector(SEL); if (nb) { btn = nb; io.observe(btn); } }
      var r = btn.getBoundingClientRect();
      var past = btn.offsetParent !== null && r.bottom < 0;
      var foot = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
      var show = past && !foot && window.innerWidth <= 768;
      if (show) { fill(); html.style.setProperty('--ud-sticky-h', bar.offsetHeight + 'px'); }
      if (html.classList.contains('ud-sticky-on') !== show) {
        html.classList.toggle('ud-sticky-on', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        bEl.tabIndex = show ? 0 : -1;
      }
    }
    function soon() { if (!raf) raf = requestAnimationFrame(check); }
    io = new IntersectionObserver(soon);
    io.observe(btn);
    if (footer) io.observe(footer);
    window.addEventListener('scroll', soon, { passive: true });
    window.addEventListener('resize', soon);
    bEl.addEventListener('click', function () {
      if (!btn.isConnected) btn = mn.querySelector(SEL) || btn;
      if (btn.disabled) return;
      // Simon 2026-10-03: tag the line (_ud_src=sticky, hidden at checkout) through assets/upside-cart-bridge.js,
      // then press the real button so the theme / cart drawer handle the add exactly as before
      var B = window.UDCartBridge, form = btn.closest('form');
      var go = function () { if (!btn.disabled) btn.click(); setTimeout(fill, 600); };
      if (B && B.tagForm && form) B.tagForm(form, 'sticky').then(go, go); else go();
    });
    document.addEventListener('change', function () { setTimeout(fill, 80); }, true);
    fill();
    check();
  }

  // ---------- 6. default format = most sold one ----------
  // Simon 2026-10-03: a product page opens on the format customers buy most (facts[handle][4], last 90 days
  // of orders, assets/upside-card-facts.json) instead of the theme default (first available, often the 24 Pack).
  // Never when the URL names a variant (?variant=). Selected the way a customer click does (the radio),
  // so price, unit price, photo, Add to Cart id, the subscribe block and the URL all follow.
  // Safety: if the theme does not move the hidden variant id with it, the original choice is put back.
  function defaultFormat(prod, f) {
    if (/[?&]variant=/.test(location.search)) return;
    if (!prod || !prod.variants || prod.variants.length < 2 || !f || !f[4]) return;
    var want = prod.variants.filter(function (v) { return v.id === +f[4] && v.available; })[0];
    if (!want) return;
    var mn = main(); if (!mn) return;
    var idEl = mn.querySelector('form[action*="/cart/add"] [name="id"]');
    if (!idEl || String(idEl.value) === String(want.id)) return;
    var before = String(idEl.value);
    var picks = [], ok = true;
    (prod.options || []).forEach(function (o, i) {
      var key = 'option' + (i + 1), val = want[key];
      var radios = mn.querySelectorAll('input[type="radio"][data-index="' + key + '"][data-variant-input]');
      var sel = mn.querySelector('select[data-index="' + key + '"][data-variant-input]');
      var hit = null;
      radios.forEach(function (r) { if (r.value === val) hit = r; });
      if (hit) {
        var box = hit.closest('.variant-input');
        if (hit.disabled || (box && box.offsetParent === null && radios[0].offsetParent !== null)) ok = false;
        if (!hit.checked) picks.push(function () { hit.click(); });
      } else if (sel) {
        if (sel.value !== val) picks.push(function () { sel.value = val; sel.dispatchEvent(new Event('change', { bubbles: true })); });
      } else ok = false;
    });
    if (!ok || !picks.length) return;
    var undo = [];
    mn.querySelectorAll('input[type="radio"][data-variant-input]:checked').forEach(function (r) { undo.push(r); });
    picks.forEach(function (p) { p(); });
    setTimeout(function () {
      var now = mn.querySelector('form[action*="/cart/add"] [name="id"]');
      if (now && String(now.value) === String(want.id)) return;
      // the theme did not follow: put the original format back so what is shown = what is added
      undo.forEach(function (r) { if (!r.checked) r.click(); });
      var again = mn.querySelector('form[action*="/cart/add"] [name="id"]');
      if (again && String(again.value) !== before) { again.value = before; }
    }, 400);
  }

  // ---------- 4. Ask Alix under the photo (desktop) ----------
  function alix() {
    if (window.innerWidth < 769) return;
    var mn = main(); if (!mn) return;
    var frame = mn.querySelector('iframe.bpEmbeddedWebchat');
    var panel = frame && (frame.closest('[data-product-blocks] > *') || frame.parentNode);
    var photos = mn.querySelector('.product__photos');
    if (!panel || !photos) return;
    // Alix already shows its own suggested questions: just move the panel under the photo
    var box = document.createElement('div');
    box.className = 'ud-alix';
    photos.parentNode.insertBefore(box, photos.nextSibling);
    box.appendChild(panel);
  }
})();
